import { cx } from 'emotion';
import { applySpec } from 'ramda';
import React, {
  Fragment, useCallback, useRef, useState,
} from 'react';

import { actions } from '@ezugi/bootstrap';
import { useAppState } from '@ezugi/bootstrap/src/hooks/useAppState';
import { useIntl } from '@ezugi/bootstrap/src/hooks/useIntl';
import { Button, Icon } from '@ezugi/primitives';
import { getThemeColor } from '@ezugi/ui/theme';
import { DeviceInfo } from '@ezugi/utils';

import pieIcon from '../../../../assets/icons/pie.svg';
import StatsIcon from '../../../../assets/icons/statistics.svg';
import ToggleSelect from '../../../../components/LastRounds/ToggleSelect/ToggleSelect';
import { toggleSelectClassName } from '../../../../components/LastRounds/style';
import Roadmap from '../../../../components/Roadmap';
import { showOddEvenSelector } from '../../../../store/selectors/config';
import { dropdownContainerClassName } from '../../../MobileStatistics/style';
import { Section } from '../../style';
import { Container } from '../style';
import { leftContainerClassName, mobileClassName } from './style';

const { menuActions } = actions;

const localeKeys = {
  statistics: 'general.statistics',
  roadmap: 'sicbo_ui.roadmap',
  smallAndBig: 'sicbo_ui.small_and_big',
  oddAndEven: 'sicbo_ui.odd_and_even',
};

const spec = applySpec({
  showOddAndEven: showOddEvenSelector,
});

export default function Left(props) {
  const [ { showOddAndEven }, dispatch ] = useAppState(spec);
  const { statistics, roadmap, smallAndBig, oddAndEven } = useIntl({
    keys: localeKeys,
  });
  const dropdownContainerRef = useRef();

  const localizedList = [ smallAndBig, showOddAndEven && oddAndEven ].filter(
    Boolean
  );

  const [ roadMapOption, setRoadMapOption ] = useState(0);

  const setMenu = useCallback(
    (widget) => dispatch(menuActions.menu.set(widget)),
    [ dispatch ]
  );

  return (
    <Section
      data-name="left-section"
      {...props}
      className={cx({ [mobileClassName]: DeviceInfo.isHandheld }, props.className)}
    >
      {DeviceInfo.isHandheld ? (
        <Button
          style={{
            background: getThemeColor('background', 0.2),
          }}
          onClick={() => setMenu({
            widget: {
              label: statistics,
              key: 'stats',
              'data-e2e': 'menu_link_stats',
              icon: pieIcon,
              onClick: () => undefined,
              drawer: true,
            },
            drawerBackIcon: false,
          })}
        >
          <Icon svg={pieIcon} />
        </Button>
      ) : (
        <Fragment>
          <div
            ref={dropdownContainerRef}
            className={dropdownContainerClassName}
          />
          <Container className={leftContainerClassName}>
            <ToggleSelect
              list={localizedList}
              iconSvg={StatsIcon}
              defaultActive={0}
              onToggle={(value) => setRoadMapOption(value)}
              className={toggleSelectClassName}
              title={roadmap}
              ref={dropdownContainerRef}
            />
            <Roadmap roadMapOption={roadMapOption} />
          </Container>
        </Fragment>
      )}
    </Section>
  );
}
